// Функция квиза
const parent = document.querySelector('.ordering-page') || null

function initOrderingPage() {
	if (!parent) return
	const btn = parent.querySelector('.Checkout__desc-btns > .Button')
	const sections = parent.querySelectorAll('.ordering-page__list-item')
	const complete = parent.querySelector('.selectable-complete')

	setInterval(() => {
		const successSections = parent.querySelectorAll(
			'.ordering-page__list-item--success, .ordering-page__list-item--success-last'
		)
		if (successSections.length === sections.length) {
			btn.classList.remove('Button--disabled')
		} else {
			btn.classList.add('Button--disabled')
		}
	}, 500)

	// sections[sections.length - 1].oninput = e => {
	//     e.preventDefault()
	//     let delivery = parent.querySelector('[type="Самовывоз"]') ? true : false

	//     if (validateOrdering(sections[sections.length - 1], delivery) == 'valid') {
	//         sectionSuccess(sections[sections.length - 1])
	//     } else {
	//         sectionSelect(sections[sections.length - 1])
	//     }
	// }

	complete.onclick = e => {
		e.preventDefault()
		let delivery = parent.querySelector('[type="Самовывоз"]') ? true : false

		if (validateOrdering(sections[sections.length - 1], delivery) == 'valid') {
			sectionSuccess(sections[sections.length - 1])
		} else {
			sectionSelect(sections[sections.length - 1])
		}
	}

	btn.classList.add('Button--disabled')

	// Navigation
	sections.forEach((section, id) => {
		const next = section.querySelector('.selectable-next') || null
		const prev = section.querySelector('.selectable-prev') || null
		const edit = section.querySelector('.ordering-page__list-action > span')

		if (next) {
			next.onclick = e => {
				e.preventDefault()
				sectionSuccess(section)
				sectionSelect(sections[id + 1])
				paymentBuyer()
			}
		}

		if (prev) {
			prev.onclick = e => {
				e.preventDefault()
				sectionSelect(sections[id - 1])
				sectionDisabled(section)
				paymentBuyer()
			}
		}

		edit.onclick = e => {
			e.preventDefault()

			const fromSection = [...sections]
				.filter(
					sec =>
						sec.classList.contains('ordering-page__list-item--select') ||
						sec.classList.contains('ordering-page__list-item--success-last')
				)
				.pop()
			if (
				!fromSection.classList.contains(
					'ordering-page__list-item--success-last'
				) ||
				!fromSection.classList.contains('ordering-page__list-item--success')
			) {
				sectionDisabled(fromSection)
			}
			sectionSelect(section, fromSection)
		}
	})
}

function sectionSuccess(section) {
	section.classList.remove('ordering-page__list-item--select')

	if (section.querySelector('#finalForm')) {
		section.classList.add('ordering-page__list-item--success-last')
	} else {
		section.classList.add('ordering-page__list-item--success')
	}
}

function sectionSelect(section, fromSection = null) {
	section.classList.remove('ordering-page__list-item--disable')
	section.classList.add('ordering-page__list-item--select')

	if (section.querySelector('#finalForm')) {
		section.classList.remove('ordering-page__list-item--success-last')

		setTimeout(() => {
			let delivery = parent.querySelector('[type="Самовывоз"]') ? true : false

			if (fromSection && fromSection !== section) {
				if (validateOrdering(section, delivery) == 'valid') {
					sectionSuccess(section)
				} else {
					// sectionSelect(section)
				}
			}
		}, 500)
	} else {
		section.classList.remove('ordering-page__list-item--success')
	}
}

function sectionDisabled(section) {
	section.classList.add('ordering-page__list-item--disable')
	section.classList.remove('ordering-page__list-item--select')

	if (section.querySelector('#finalForm')) {
		section.classList.remove('ordering-page__list-item--success-last')
	} else {
		section.classList.remove('ordering-page__list-item--success')
	}
}

function paymentBuyer(section) {
	const buyer = parent.querySelector('.ordering-page__list-item--buyer-f')
	const area = parent.querySelector('.ordering-page__list-item--payment')

	if (section !== buyer.closest('.ordering-page__list-item')) return

	if (buyer.getAttribute('type') === 'Юридическое лицо') {
		const subtitle = area.querySelector(
			innerWidth < 867
				? '.ordering-page__list-subtitle-text'
				: '.ordering-page__list-extra-text'
		)
		subtitle.textContent = 'Безналичный расчет'

		const first = area.querySelector('[data-type="Юридическое лицо"]')
		const second = area.querySelector('[data-type="Физическое лицо"]')
		const checkbox = first.querySelector('[type="radio"]')

		second.style = 'display: none;'
		first.style = ''
		second.querySelectorAll('[checked]').forEach(checkbox => {
			checkbox.removeAttribute('checked')
			checkbox.checked = false
		})
		checkbox.checked = true
		checkbox.setAttribute('checked', '')
	} else if (buyer.getAttribute('type') === 'Физическое лицо') {
		const first = area.querySelector('[data-type="Юридическое лицо"]')
		const second = area.querySelector('[data-type="Физическое лицо"]')

		const checkbox = second.querySelector('[type="radio"]')

		second.style = ''
		first.style = 'display: none;'
		first.querySelectorAll('[checked]').forEach(checkbox => {
			checkbox.removeAttribute('checked')
			checkbox.checked = false
		})

		checkbox.checked = true
		checkbox.setAttribute('checked', '')
	}
}

function stepsHandling(section, payload) {
	const subtitle = section.querySelector(
		innerWidth < 867
			? '.ordering-page__list-subtitle-text'
			: '.ordering-page__list-extra-text'
	)
	const lastSection = parent.querySelectorAll('.ordering-page__list-item')[
		parent.querySelectorAll('.ordering-page__list-item').length - 1
	]

	section.setAttribute('type', payload)
	subtitle.textContent = payload

	const bottomPart = section.querySelectorAll('[data-type-bottom]')

	paymentBuyer(section)

	if (bottomPart.length) {
		bottomPart.forEach(b => {
			b.style.display = 'none'

			if (b.getAttribute('data-type-bottom') === payload) {
				b.removeAttribute('style')
			}
		})
	}

	// if (section.getAttribute('type') === 'Самовывоз') {
	//     lastSection.querySelector('.ordering-page__wrapper-comments').style = 'display: none;'
	// } else {
	//     lastSection.querySelector('.ordering-page__wrapper-comments').style = ''
	// }
}

function validateInput(input, rules) {
  // Очищаем предыдущие сообщения об ошибках
  clearErrorMessage(input);

  // Проходим по всем правилам валидации
  for (let rule of rules) {
    const isValid = rule.validator(input.value);
    if (!isValid) {
      showErrorMessage(input, rule.message);
      return false;
    }
  }

  // Если все правила пройдены успешно
  return true;
}

function showErrorMessage(input, message) {
  // Проверяем, существует ли уже сообщение об ошибке
  let errorElement = input.parentElement.querySelector('.input-validation__message');

  // Если элемент с ошибкой не существует, создаем его
  if (!errorElement) {
    errorElement = document.createElement('div');
    errorElement.className = 'input-validation__message';
    errorElement.style.marginTop = '5px';
    errorElement.style.textAlign = 'right';
    input.parentElement.parentElement.appendChild(errorElement);
  }

  // Устанавливаем сообщение об ошибке
  errorElement.textContent = message;

  // Добавляем класс ошибки к инпуту
  input.classList.add('input-error');
}

function clearErrorMessage(input) {
  // Находим элемент с сообщением об ошибке, если он существует
  const errorElement = input.parentElement.parentElement.querySelector('.input-validation__message');
  console.log(errorElement);

  if (errorElement) {
    // Очищаем сообщение
    errorElement.textContent = '';
    errorElement.remove();
  }

  // Удаляем класс ошибки с инпута
  input.classList.remove('input-error');
}

// Правила валидации
const validationRules = {
  name: [
    {
      validator: (value) => value.length >= 2,
      message: 'Имя должно содержать не менее 2 символов'
    }
  ],
  mail: [
    {
      validator: (value) => value.length >= 2,
      message: 'Email должен содержать не менее 2 символов'
    },
    {
      validator: (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value),
      message: 'Введите корректный email адрес'
    }
  ],
  tel: [
    {
      validator: (value) => value.length >= 2,
      message: 'Телефон должен содержать не менее 2 символов'
    },
    {
      validator: (value) => /^[+]?[0-9\s-()]{5,}$/.test(value),
      message: 'Введите корректный номер телефона'
    }
  ],
  city: [
    {
      validator: (value) => value.length >= 2,
      message: 'Название города должно содержать не менее 2 символов'
    }
  ],
  address: [
    {
      validator: (value) => value.length >= 2,
      message: 'Адрес должен содержать не менее 2 символов'
    }
  ]
};

// Функция для проверки формы целиком
function validateForm(form, delivery = true) {
  const fields = [
    form.querySelector('[name="name"]'),
    form.querySelector('[name="mail"]'),
    form.querySelector('[name="tel"]'),
    form.querySelector('[name="city"]'),
    form.querySelector('[name="checkbox"]')
  ];

  if (!delivery) {
    fields.push(form.querySelector('[name="address"]'));
  }

  // Проверка согласия с политикой конфиденциальности
  const privacyPolicy = document.querySelector('.Privacy-policy');
  const privacyPolicyInput = privacyPolicy.querySelector('.Privacy-policy__input');
  const privacyPolicyInputMsg = privacyPolicy.querySelector('.input-validation__message');

  if (!privacyPolicyInput.checked) {
    privacyPolicyInputMsg.textContent = 'Вы не приняли условия соглашения.';
  } else {
    privacyPolicyInputMsg.textContent = '';
  }

  // Валидация всех полей
  let isValid = true;

  for (let field of fields) {
    if (field.name === 'checkbox') {
      if (!field.checked) {
        showErrorMessage(field, 'Необходимо отметить этот пункт');
        isValid = false;
      }
    } else if (validationRules[field.name]) {
      // Для каждого поля применяем соответствующие правила валидации
      const fieldIsValid = validateInput(field, validationRules[field.name]);
      if (!fieldIsValid) {
        isValid = false;
      }
    }
  }

  return isValid && privacyPolicyInput.checked;
}

// Функция validateOrdering для совместимости с существующим кодом
function validateOrdering(parent, delivery) {
  const privacyPolicy = document.querySelector('.Privacy-policy');
  const privacyPolicyInput = privacyPolicy.querySelector('.Privacy-policy__input');
  const privacyPolicyInputMsg = privacyPolicy.querySelector('.input-validation__message');

  if (!privacyPolicyInput.checked) {
    privacyPolicyInputMsg.textContent = 'Вы не приняли условия соглашения.';
  } else {
    privacyPolicyInputMsg.textContent = ' ';
  }

  const fields = [
    parent.querySelector('[name="name"]'),
    parent.querySelector('[name="mail"]'),
    parent.querySelector('[name="tel"]'),
    parent.querySelector('[name="city"]'),
    parent.querySelector('[name="checkbox"]'),
  ];

  if (!delivery) {
    fields.push(parent.querySelector('[name="address"]'));
  }

  let requireInputCounter = 0;
  for (let field of fields) {
    // Проверка на null или undefined (если поле не найдено)
    if (!field) continue;

    if (field.name == 'checkbox') {
      if (field.checked) {
        requireInputCounter += 1;
      } else {
        showErrorMessage(field, 'Необходимо отметить этот пункт');
      }
    } else {
      // Применяем правила валидации, если они определены для этого поля
      if (validationRules[field.name]) {
        const isValid = validateInput(field, validationRules[field.name]);
        if (isValid && field.value.length > 2) {
          requireInputCounter += 1;
        }
      } else if (field.value.length > 2) {
        requireInputCounter += 1;
      }
    }
  }

  return requireInputCounter === fields.length ? 'valid' : 'invalid';
}

// Пример использования при отправке формы
document.querySelector('form').addEventListener('submit', function(e) {
  const isDelivery = true; // или false в зависимости от условий

  if (!validateForm(this, isDelivery)) {
    e.preventDefault(); // Предотвращаем отправку формы, если валидация не пройдена
    console.log('Форма содержит ошибки!');
  }
});

// Пример использования для валидации при потере фокуса
document.querySelectorAll('input, textarea, select').forEach(input => {
  if (input.name && validationRules[input.name]) {
    input.addEventListener('blur', function() {
      validateInput(this, validationRules[this.name]);
    });
  }
});

// Обработчик для чекбокса политики конфиденциальности
const privacyPolicyInput = document.querySelector('.Privacy-policy__input');
if (privacyPolicyInput) {
  privacyPolicyInput.addEventListener('click', e => {
    const privacyPolicyInputMsg = document.querySelector('.Privacy-policy .input-validation__message');
    if (e.target.checked) {
      privacyPolicyInputMsg.textContent = '';
    }
  });
}